import { datadogRum } from '@datadog/browser-rum';

const initializeDatadog = () => {
  if (JSON.parse(process.env.REACT_APP_DDTRACE || 'false')) {
    datadogRum.init({
      applicationId: process.env?.REACT_APP_DD_APPLICATION_ID as string,
      clientToken: process.env?.REACT_APP_DD_CLIENT_TOKEN as string,
      site: 'datadoghq.com',
      service: 'partners-app-promo-code',
      env: process.env.PARTNERS_ENVIRONMENT,
      sampleRate: 100,
      premiumSampleRate: 100,
      trackInteractions: true,
      silentMultipleInit: true,
      version: '1.0.0',
    });

    datadogRum.startSessionReplayRecording();
  }
};

export default initializeDatadog;
